import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import { PropTypeShapes } from "../../types";
import FormDurationPicker from "../form/FormDurationPicker";
import MenuPopover from "./MenuPopover";

export default class DurationMenuPopover extends PureComponent {
  constructor(props) {
    super(props);

    this.state = { duration: null };

    this.setDuration = this.setDuration.bind(this);
    this._duration = this.state.duration;
    this.onOk = this.onOk.bind(this);
  }

  setDuration(newDuration) {
    this.setState({ duration: newDuration });
    this._duration = newDuration;
  }

  onOk() {
    this.props.onOk(this._duration);
  }

  render() {
    const { target, isOpen, title } = this.props;
    return (
      <MenuPopover
        target={target}
        isOpen={isOpen}
        title={title}
        onOk={this.onOk}
        onEnter={this.onOk}
        onCancel={this.props.onCancel}
        buttonLabel="Ok"
        description="Please enter the duration"
      >
        <FormDurationPicker
          value={this.state.duration}
          calendar={this.props.calendar}
          onChange={this.setDuration}
          autoFocus={true}
        />
      </MenuPopover>
    );
  }
}

DurationMenuPopover.propTypes = {
  target: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  calendar: PropTypeShapes.calendar.isRequired
};
